import global from "../../config/global";
import storeActions from "../../store/actions";

const isFreePlan = () => {
  return global.store.getState().payment?.plan?.alias === global.constants.PLANS.FREE
}

const isPremiumPlan = () => {
  return global.store.getState().payment?.plan?.alias === global.constants.PLANS.PREMIUM
}

const isFamilyPlan = () => {
  return global.store.getState().payment?.plan?.alias === global.constants.PLANS.FAMILY
}

const isEnterpriseMember = () => {
  return global.store.getState().auth?.userInfo?.pwd_user_type === 'enterprise'
}

const isFamilyOwner = () => {
  return [global.constants.PLANS.FAMILY, global.constants.PLANS.LIFETIME_FAMILY, global.constants.PLANS.LIFETIME_TEAM].includes(
    global.store.getState().payment?.plan?.alias
  )
}

const isLifeTimeUser = () => {
  const ALIASES = [
    global.constants.PLANS.LIFETIME_FAMILY,
    global.constants.PLANS.LIFETIME_TEAM,
    global.constants.PLANS.LIFETIME_PREMIUM
  ]
  return (
    ALIASES.includes(global.store.getState().payment?.plan?.alias) ||
    ALIASES.includes(global.store.getState().auth?.userInfo?.pwd_plan)
  )
}

const getPercentageStatus = (percentage) => {
  if (percentage > 0.8) {
    return 'exception'
  }
  if (percentage > 0.5) {
    return 'warning'
  }
  return 'success'
}

const isPremiumFeaturesAvailable = () => {
  return (
    global.store.getState().auth?.userInfo?.pwd_user_type === 'enterprise' ||
    global.store.getState().payment?.plan?.alias !== global.constants.PLANS.FREE
  )
}

const isFamilyUser = () => {
  const plan = global.store.getState().payment?.plan;
  return [
    global.constants.PLANS.LIFETIME_PREMIUM,
    global.constants.PLANS.PREMIUM
  ].includes(plan?.alias) && plan?.is_family 
}

const isPersonalUser = () => {
  return global.store.getState().auth?.userInfo?.pwd_user_type !== 'enterprise'
}

const checkingHandleAttachment = () => {
  if (isFreePlan() && isPersonalUser()) {
    global.store.dispatch(storeActions.updatePlanNoticeVisible(true));
    return false
  }
  return true
}


export default {
  isFreePlan,
  isPremiumPlan,
  isFamilyPlan,
  isEnterpriseMember,
  isFamilyOwner,
  isLifeTimeUser,
  getPercentageStatus,
  isPremiumFeaturesAvailable,
  isFamilyUser,
  isPersonalUser,
  checkingHandleAttachment
}